//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState, mapGetters } from "vuex";
import { date } from "quasar";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQChip from "@/components/Generics/AQChip/AQChip.vue";
import qAuStatusInfo from "@/components/Generics/qAuStatusInfo.vue";
import i18n from "@/i18n/index";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import { setPluginIcon } from "@/assets/js/appFunc";
import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";
import submitComment from "./submitComment.vue";
import timelineTaskDetails from "./timeline-task-details.vue";
import { SIZE_TIMELINE_PLUGIN, PI_USER_ACTIONS } from "./size-canvas-timeline.const";
import TimelineDataModel from "./TimelineDataModel.vue";
import TimelineProcessModal from "./TimelineProcessModal.vue";

export default {
    name: "Timeline",
    components: {
        AQButton,
        AQInput,
        submitComment,
        timelineTaskDetails,
        qAuStatusInfo,
        TimelineDataModel,
        AQTooltip,
        AQBadge,
        TimelineProcessModal,
        AQChip
    },
    filters: {
        date: (value) => `${date.formatDate(value, "DD.MM.YYYY")} at ${date.formatDate(value, "HH:mm:ss")}`,
        actionTypeRename: (value) => {
            const actionMappings = {
                RETRY: i18n.t("timeline.retried"),
                DOWNLOAD_LOG: i18n.t("timeline.downloadedLog"),
                VIEW_LOG: i18n.t("timeline.viewedLog"),
                TERMINATE: i18n.t("timeline.terminated"),
                ARCHIVE: i18n.t("timeline.archived"),
                SAVE_DATA_MODEL: i18n.t("timeline.savedDataModel"),
                DELETE_DATA_MODEL_VALUES: i18n.t("timeline.deleteDataModel"),
                DELETE_DATA_MODEL_AUDIT: i18n.t("timeline.deleteDataModelAudit"),
                ANONYMIZE_PERSONAL_INFO: i18n.t("timeline.anonymizeInfo")
            };
            return actionMappings[value];
        }
    },
    props: {
        processInstance: {
            type: String,
            default: ""
        },
        applicationId: {
            type: String,
            default: ""
        },
        showExpandTimelineArrow: {
            type: Boolean,
            default: false
        },
        isFromPI: {
            type: Boolean,
            default: false
        },
        actionFinished: {
            type: Boolean,
            default: false
        },
        refreshTimeline: {
            type: Boolean,
            default: false
        },
        hideHeaderDetails: {
            type: Boolean,
            default: false
        }

    },
    data() {
        return {
            pluginList: [],
            pluginTypeList: [],
            showDataModel: "",
            currenentStageAudit: {},
            timeline: [], // all timeline data
            filterStages: [], // filtered timeline data
            temporaryFilterData: [],
            stageExcludeStatus: ["GENERAL_START_PLUGIN", "GENERAL_END_PLUGIN"],
            stageExcludeDetails: [
                "EXCLUSIVE_GATEWAY_PLUGIN",
                "PARALLEL_GATEWAY_PLUGIN",
                "JOIN_GATEWAY_PLUGIN",
                "GENERAL_START_PLUGIN",
                "PROCESS_PLUGIN",
                "GENERAL_END_PLUGIN"
            ],
            stageExcludeDetails2: [
                "EXCLUSIVE_GATEWAY_PLUGIN",
                "PARALLEL_GATEWAY_PLUGIN",
                "JOIN_GATEWAY_PLUGIN",
                "GENERAL_START_PLUGIN",
                "GENERAL_END_PLUGIN"
            ],
            sizeCanvas: SIZE_TIMELINE_PLUGIN,
            searchValue: "",
            showProcessModal: false,
            currentIndexOpened: null,
            currentCollapseIndex: null,
            currentCollapseSubLevelIndex: null, // current sublevel approval matrix index
            currentCollapseDecisionGrIndex: null, // current decision group index approval matrix
            currentCollapseUserTaskIndex: null, // current sublevel user task approval matrix index
            currentCollapseExternalLevelIndex: null, // current external task index
            currentStageDetails: [], // current opened stage details
            currentDecisionGroupDetails: [], // current opened decision group details - approval matrix
            currentSubTaskDetails: [], // current opened sub-stage details - approval matrix
            currentSubLevelUsersTask: [], // current opened sub-level assigned users tasks
            currentSubUserTaskDetails: [], // current opened sub-level assigned user task details
            isApprovalMatrix: false, // isApprovalMatrix Task
            isExternalTask: false, // isExternalTask Task
            isParallelHT: false,
            taskNumberToShow: 5, // number of tasks to show and load more,
            taskApprovalMatrixOpened: null,
            taskExternalTaskOpened: false,
            singleExternaltask: false,
            isChildInstance: false,
            isChildAsync: false,
            currentProcessDetails: null,
            instanceID: "",
            instanceName: "",
            changeInComments: false,
            deletedInstance: false,
            excludeStageType: ["RETRY", "DOWNLOAD_LOG", "VIEW_LOG", "TERMINATE", "ARCHIVE", "DELETE_DATA_MODEL_VALUES",
                "DELETE_DATA_MODEL_AUDIT", "ANONYMIZE_PERSONAL_INFO"]
        };
    },
    computed: {
        ...mapState("diagrams", ["auditTrail"]),
        ...mapState("components", ["isSmallScreen"]),
        ...mapGetters("diagrams", [
            "diagramPlugins", "getAllTimelineTaskDetails", "getAllTimelineAppLevelDetails"
        ]),
        ...mapGetters("admin", ["getIfTimelineEnabled", "getProcessInspectorById"]),

        checkTasksLength() {
            let tasksLength = false;
            if (this.filterStages.length) {
                if (this.temporaryFilterData && this.temporaryFilterData.length) {
                    tasksLength = this.filterStages.length < this.temporaryFilterData.length;
                } else {
                    tasksLength = this.filterStages.length < this.timeline.length;
                }
            }
            return tasksLength;
        }
    },
    watch: {
        refreshTimeline: {
            handler(val) {
                if (val) {
                    this.initTimeline();
                }
            }
        },
        hideHeaderDetails: {
            handler() {
                this.initTimeline();
            }
        },
        actionFinished: {
            handler(val) {
                if (val) {
                    this.filterStages = [];
                    this.initTimeline();
                    this.$emit("changeActionFinished");
                    this.currentCollapseIndex = null;
                }
            }
        },
        filterStages: {
            handler(value) {
                for (let i = 0; i < value.length; i++) {
                    if (value[i].type === "API_PLUGIN") {
                        if (value[i].activityName === "Call Api") {
                            value[i].activityName = this.$t("timeline.apiService");
                        } else if (value[i].activityName.includes("Call Api")) {
                            value[i].activityName = value[i].activityName.replace("Call Api", this.$t("timeline.apiService"));
                        }
                    }
                }
            },
            immediate: true
        }
    },
    created() {
        this.actPluginList().then(response => {
            this.pluginList = response.data || [];
            this.pluginTypeList = this.pluginList.map(el => el.type);
        });
        if (!this.isFromPI) {
            this.timelineEnabledFeature();
        }
        this.initTimeline();
        this.$root.$on("refreshTimeline", () => {
            this.changeInComments = true;
            this.initTimeline();
            this.openTaskDetails();
        });
    },
    methods: {
        ...mapActions("admin", ["timelineEnabledFeature", "actPluginList"]),
        setPluginIcon,
        getStageIcon(stage) {
            let stageIcon = "";
            if (this.pluginTypeList.includes(stage.type)) {
                const currentType = this.pluginList.find(plugin => plugin.type === stage.type);
                const iconObj = JSON.parse(currentType.metadata);
                const iconDecoded = window.atob(iconObj.icon);
                const blob = new Blob([iconDecoded], { type: "image/svg+xml" });
                stageIcon = URL.createObjectURL(blob);
            } else {
                stageIcon = this.setPluginIcon(stage.type);
            }
            return stageIcon;
        },
        initTimeline() {
            this.deletedInstance = false;
            this.$store.dispatch("diagrams/getTasksTimeline",
                { processInstance: this.processInstance, isFromPI: this.isFromPI, appId: this.applicationId }).then(
                data => {
                    this.isChildInstance = !data.extraData.parent;
                    this.isChildAsync = data.extraData.childAsync;
                    this.timeline = data.tasks.filter((element) => {
                        if (element.type === "GENERAL_START_PLUGIN" && element.byUser) {
                            element.decision = this.$t("timeline.startAction");
                        }
                        element.showStatus = !this.stageExcludeStatus.includes(element.type);
                        let type; const
                            statusType = this.isFromPI ? !this.isFromPI : !this.getIfTimelineEnabled;
                        if (statusType) {
                            type = !["GENERATE_DOCUMENT_PLUGIN", "BLOCKCHAIN_PLUGIN", "BLOCKCHAIN_EVENT_PLUGIN",
                                "API_PLUGIN", "DATA_EXPORT_PLUGIN", "ADVANCED_LOGIC_PLUGIN", "EXPOSE_API_PLUGIN"].includes(element.type);
                        } else {
                            type = true;
                        }
                        return type;
                    });
                    this.loadMoreTasks();
                    this.loadTasksAfterRefresh();
                },
                () => {
                    this.deletedInstance = true;
                }
            );
        },
        showNameOrIdDependsOnFulltimeline(stage) {
            const { startedProcessDefinitionName, startedProcessInstanceId } = stage.timelineTaskDetailsImp;
            return this.isFromPI || this.getIfTimelineEnabled ? startedProcessInstanceId : startedProcessDefinitionName;
        },
        openModalTimeline(stage) {
            if (stage.type === "PROCESS_PLUGIN") {
                this.currentProcessDetails = stage;
                this.instanceID = stage.timelineTaskDetailsImp.startedProcessInstanceId;
                this.instanceName = stage.activityName;
                this.showProcessModal = true;
            }
        },
        resetValues() {
            this.currentProcessDetails = null;
            this.instanceID = "";
        },
        getChipProps(stage, user, fromDelegation) {
            let typeToReturn = "user";
            let contentToReturn = this.$t("timeline.system");
            if (user) {
                if (user.name && (user.name === "System" || user.name === null)) {
                    typeToReturn = "default";
                } else if ((fromDelegation && user.delegatorStatus && user.delegatorStatus === "DISABLED") || (user.status && user.status === "DISABLED")) {
                    typeToReturn = "disabledUser";
                } else if ((user.type && user.type === "USER") || this.checkIfSmsEmail) {
                    typeToReturn = "user";
                } else if (user.type && user.type === "GROUP") {
                    typeToReturn = "group";
                }
                if (fromDelegation) {
                    contentToReturn = user.delegatorName;
                } else {
                    contentToReturn = user.name ? user.name.trim() : user.email;
                }
            } else if (stage && stage.type === "PROCESS_PLUGIN") {
                typeToReturn = "default";
            } else if (stage && stage.type === "EXPOSE_API_PLUGIN" && stage.byUser === null) {
                typeToReturn = "default";
            }
            return {
                type: typeToReturn,
                content: contentToReturn
            };
        },
        showDataAuditIcon(stage, isDataAuditIcon) {
            const dataToCheck = isDataAuditIcon ? stage.dataModelAuditId : stage.dataAuditDeleted;
            let showIcon = false;
            if ((this.isFromPI || this.getIfTimelineEnabled) && dataToCheck) {
                if (stage.type === "PROCESS_PLUGIN" && stage.timelineTaskDetailsImp && stage.timelineTaskDetailsImp.async) {
                    showIcon = true;
                } else if (stage.type === "GENERAL_START_PLUGIN" && dataToCheck) {
                    showIcon = true;
                }
            }
            return showIcon;
        },
        decisionGroupDescription(item) {
            let description = "";
            if (item.right === "appr") {
                if (item.decisionType === "singular") {
                    description = this.$t("timeline.singularDecision");
                } else {
                    description = this.$tc("timeline.groupDecision", item.threshold);
                }
            } else if (item.right === "eval") {
                description = this.$t("timeline.evaluatorDecision");
            } else if (item.right === "ovr") {
                description = this.$t("timeline.overriderDecision");
            }
            return description;
        },
        remainingUsersToShowFct(val) {
            return val.slice(1, val.length);
        },
        getFileName(stage) {
            return stage.attachmentDetails && stage.attachmentDetails.filename ? stage.attachmentDetails.filename : "";
        },
        checkIfSmsEmail(val) {
            return val === "SMS" || val === "EMAIL";
        },
        showDataAudit(data) {
            this.currenentStageAudit = data;
            this.showDataModel = data.dataModelAuditId;
        },
        checkEmailAndAsignees(task) {
            return this.checkIfSmsEmail(task.lastDetails.actionTaken)
                    || ((task.lastDetails.actionTaken === "ASSIGN" || task.lastDetails.actionTaken === "REASSIGN")
                    && task.lastDetails.asignees && task.lastDetails.asignees.length && task.lastDetails.asignees[0].name
                    && task.lastDetails.asignees[0].name !== "System");
        },
        checkExecutedTasks(task) {
            return task.lastDetails.actionTaken !== "ASSIGN" && task.lastDetails.executedBy
            && task.lastDetails.executedBy.name && task.lastDetails.executedBy.name !== "System";
        },
        checkNoEmailOrSMS(task) {
            return task.lastDetails.actionTaken !== "EMAIL" && task.lastDetails.actionTaken !== "SMS" && !task.lastDetails.asignees;
        },
        openComment(event, commInstanceId) {
            if (event.currentTarget.classList.contains("comment-opened")) {
                event.currentTarget.classList.remove("comment-opened");
                event.currentTarget.classList.remove("text-white");
                event.currentTarget.classList.add("text-black");
            } else {
                event.currentTarget.classList.add("comment-opened");
                event.currentTarget.classList.add("text-white");
                event.currentTarget.classList.remove("text-black");
            }
            if (this.$refs && this.$refs[commInstanceId] && this.$refs[commInstanceId][0] && this.$refs[commInstanceId][0].$el) {
                const instance = this.$refs[commInstanceId][0].$el;
                if (instance.classList.contains("comment-closed")) {
                    instance.classList.remove("comment-closed");
                } else {
                    instance.classList.add("comment-closed");
                }
            }
        },
        activityColor(type) {
            let color;
            const elem = this.diagramPlugins.find(curr => curr.id === type);
            if (elem) {
                color = elem.color;
            }
            return color;
        },

        /**
     * @description  open currentTask details
     */
        openTaskDetails(event, index, stage) {
            const currentClickedElement = event ? event.currentTarget : null;
            const approvalMatrixElement = this.currentCollapseIndex && this.$refs[`refcollapse-${this.currentCollapseIndex}`]
                                  && this.$refs[`refcollapse-${this.currentCollapseIndex}`][0]
                ? this.$refs[`refcollapse-${this.currentCollapseIndex}`][0] : null;
            if (this.currentCollapseIndex && approvalMatrixElement && approvalMatrixElement.$el.id === "APPROVAL_PLUGIN") {
                this.resetIconDetailsPosition(`toggle-subtask-level-icon-${this.currentCollapseIndex}`);
            }
            this.currentCollapseIndex = null;
            this.currentCollapseUserTaskIndex = null;
            this.currentCollapseSubLevelIndex = null;
            this.currentCollapseExternalLevelIndex = null;

            this.filterStages.forEach((element, i) => {
                if (i !== index && this.$refs[`toggle-parent-icon${i}`]
                && this.$refs[`toggle-parent-icon${i}`][0] && this.$refs[`toggle-parent-icon${i}`][0].$el) {
                    this.$refs[`toggle-parent-icon${i}`][0].$el.classList.remove("toggle-icon-rotate-180");
                }
            });
            let apiUrl;
            if (stage) {
                if (stage.type === "APPROVAL_PLUGIN") {
                    apiUrl = this.isFromPI ? `/engine/task/approvalMatrix/audit/${stage.id}?isProcessInspector=${this.isFromPI}`
                        : `/engine/task/approvalMatrix/audit/${stage.id}`;
                } else if (stage.type === "EXTERNAL_PLUGIN" || (stage.type === "TASK_PLUGIN" && stage.isParallelTask)) {
                    apiUrl = this.isFromPI ? `/engine/task/parallelTask/audit/${stage.id}?isProcessInspector=${this.isFromPI}`
                        : `/engine/task/parallelTask/audit/${stage.id}`;
                } else if (this.isFromPI) {
                    apiUrl = `/engine/task/audit/${stage.id}?isProcessInspector=${this.isFromPI}`;
                } else {
                    apiUrl = `/engine/task/audit/${stage.id}`;
                }
            }
            if (currentClickedElement) {
                if (currentClickedElement.classList.contains("toggle-icon-rotate-180")) {
                    currentClickedElement.classList.remove("toggle-icon-rotate-180");
                    this.$refs[`refcollapse-${index}`][0].hide();
                } else {
                    currentClickedElement.classList.add("toggle-icon-rotate-180");
                    this.$store.dispatch("diagrams/getTaskDetailsTimeline", apiUrl).then(
                        data => {
                            this.isApprovalMatrix = stage.type === "APPROVAL_PLUGIN";
                            this.isExternalTask = stage.type === "EXTERNAL_PLUGIN";
                            if (stage.type === "TASK_PLUGIN" && stage.isParallelTask) {
                                this.isParallelHT = true;
                            } else {
                                this.isParallelHT = false;
                            }
                            if (stage.type === "GENERATE_DOCUMENT_PLUGIN" && stage.attachmentDetails && stage.attachmentDetails.filename) {
                                if (data && data.length > 1 && data[0].actionTaken === "DOCUMENT_GENERATED") {
                                    data.shift();
                                }
                            }
                            this.currentStageDetails = data;
                            if (this.isExternalTask && data && data.length === 1) {
                                this.singleExternaltask = true;
                                this.currentStageDetails[0].taskDetails.unshift(data[0].lastDetails);
                            } else if (this.isExternalTask && data && data.length > 1) {
                                this.singleExternaltask = false;
                            }
                            this.$store.commit("diagrams/setTimelineTaskDetails",
                                { id: stage.id, data: this.isExternalTask ? this.currentStageDetails : data });
                            this.$refs[`refcollapse-${index}`][0].show();
                            this.currentCollapseIndex = index;
                        },
                        () => {
                            this.showNotification();
                        }
                    );
                }
            }
            this.taskApprovalMatrixOpened = null;
        },
        showNotification() {
            this.$toast.showNotify({
                type: "error",
                message: this.$t("timeline.errorTask")
            });
        },
        resetClass(index, indexParent, task, isFromApprovalMatrix, fromDecisionGroup) {
            this.currentStageDetails.forEach((element, i) => {
                if (isFromApprovalMatrix) {
                    if (i !== index && this.$refs[`toggle-subtask-level-icon-${indexParent}-${i}`]
                    && this.$refs[`toggle-subtask-level-icon-${indexParent}-${i}`][0] && this.$refs[`toggle-subtask-level-icon-${indexParent}-${i}`][0].$el) {
                        this.$refs[`toggle-subtask-level-icon-${indexParent}-${i}`][0].$el.classList.remove("toggle-icon-rotate-90");
                    }
                    if (!fromDecisionGroup) {
                        this.currentSubLevelUsersTask = task.tasks || task;
                    } else {
                        this.currentSubLevelUsersTask = [];
                    }
                } else if (i !== index && this.$refs[`toggle-external-task-icon-${indexParent}-${i}`]
                && this.$refs[`toggle-external-task-icon-${indexParent}-${i}`][0] && this.$refs[`toggle-external-task-icon-${indexParent}-${i}`][0].$el) {
                    this.$refs[`toggle-external-task-icon-${indexParent}-${i}`][0].$el.classList.remove("toggle-icon-rotate-90");
                }
            });
        },

        /**
     * @description  open currentDecisionGroups - Approval matrix
     */
        openDecisionGroupsLevel(event, indexParent, index, task, iconElem, isFromApprovalMatrix, fromDecisionGroup) {
            const currentClickedElement = this.$refs[iconElem] && this.$refs[iconElem][0] && this.$refs[iconElem][0].$el ? this.$refs[iconElem][0].$el : null;
            this.currentDecisionGroupDetails = task.timelineDecisionGroupModels;
            this.currentCollapseUserTaskIndex = null;
            this.currentCollapseExternalLevelIndex = null;
            this.taskExternalTaskOpened = false;
            if (isFromApprovalMatrix) {
                this.resetIconDetailsPosition(`toggle-decision-group-icon-${indexParent}-${index}`);
            } else {
                this.resetIconDetailsPosition(`toggle-external-task-icon-${indexParent}-${index}`);
            }
            const taskToShow = fromDecisionGroup ? task.tasks : task;
            this.resetClass(index, indexParent, taskToShow, isFromApprovalMatrix, true);

            if (currentClickedElement) {
                if (currentClickedElement.classList.contains("toggle-icon-rotate-90")) {
                    currentClickedElement.classList.remove("toggle-icon-rotate-90");
                    if (isFromApprovalMatrix) {
                        this.$refs[`collapsible-subtask-level-${indexParent}-${index}`][0].hide();
                    } else {
                        this.$refs[`collapsible-external-task-${indexParent}-${index}`][0].hide();
                    }
                } else if (!this.taskExternalTaskOpened) {
                    currentClickedElement.classList.add("toggle-icon-rotate-90");
                    if (isFromApprovalMatrix) {
                        this.$refs[`collapsible-subtask-level-${indexParent}-${index}`][0].show();
                    } else {
                        this.$refs[`collapsible-external-task-${indexParent}-${index}`][0].show();
                    }
                } else {
                    this.resetClass(index, indexParent, task, isFromApprovalMatrix);
                    if (isFromApprovalMatrix) {
                        this.$refs[`collapsible-subtask-level-${indexParent}-${index}`][0].hide();
                    } else {
                        this.$refs[`collapsible-external-task-${indexParent}-${index}`][0].hide();
                    }
                }
            }
        },

        /**
     * @description  open currentLevels - Approval matrix
     */
        openSubTaskLevel(event, indexGrandfather, indexParent, index, task, iconElem, isFromApprovalMatrix, fromDecisionGroup) {
            const currentClickedElement = this.$refs[iconElem] && this.$refs[iconElem][0] && this.$refs[iconElem][0].$el ? this.$refs[iconElem][0].$el : null;
            this.currentCollapseUserTaskIndex = null;
            this.currentCollapseDecisionGrIndex = null;
            this.currentCollapseExternalLevelIndex = null;
            // this.currentDecisionGroupDetails = task.timelineDecisionGroupModels;
            this.taskExternalTaskOpened = false;
            if (isFromApprovalMatrix) {
                this.resetIconDetailsPosition(`toggle-subtask-user-icon-${indexGrandfather}-${indexParent}-${index}`);
            } else {
                this.resetIconDetailsPosition(`toggle-external-task-icon-${indexParent}-${index}`);
            }
            const taskToShow = fromDecisionGroup ? task.tasks : task;
            this.resetClass(index, indexParent, taskToShow, isFromApprovalMatrix);

            if (currentClickedElement) {
                if (currentClickedElement.classList.contains("toggle-icon-rotate-90")) {
                    currentClickedElement.classList.remove("toggle-icon-rotate-90");
                    if (isFromApprovalMatrix) {
                        this.$refs[`collapsible-decision-group-${indexGrandfather}-${indexParent}-${index}`][0].hide();
                    } else {
                        this.$refs[`collapsible-external-task-${indexParent}-${index}`][0].hide();
                    }
                } else if (!this.taskExternalTaskOpened) {
                    currentClickedElement.classList.add("toggle-icon-rotate-90");
                    if (isFromApprovalMatrix) {
                        const collapseRef = this.$refs[`collapsible-decision-group-${indexGrandfather}-${indexParent}-${index}`][0];
                        if (collapseRef.showing) {
                            collapseRef.hide();
                            this.$nextTick(() => {
                                collapseRef.show();
                            });
                        } else {
                            collapseRef.show();
                        }
                    } else {
                        this.$refs[`collapsible-external-task-${indexParent}-${index}`][0].show();
                    }
                } else {
                    this.resetClass(index, indexParent, task, isFromApprovalMatrix);
                    if (isFromApprovalMatrix) {
                        this.$refs[`collapsible-decision-group-${indexGrandfather}-${indexParent}-${index}`][0].hide();
                    } else {
                        this.$refs[`collapsible-external-task-${indexParent}-${index}`][0].hide();
                    }
                }
            }
        },
        resetIconDetailsPosition(refIcon) {
            Object.keys(this.$refs).forEach(key => {
                if (key.includes(refIcon) && this.$refs[key] && this.$refs[key][0] && this.$refs[key][0].$el.classList.contains("toggle-icon-rotate-90")) {
                    this.$refs[key][0].$el.classList.remove("toggle-icon-rotate-90");
                    this.taskExternalTaskOpened = true;
                }
            });
        },

        /**
     * @description  open current Level Task details - Approval marix
     */
        openSubTaskUserDetails(event, index, indexParent, indexOfParent, indexOfGrandfather, userSubTask, iconElem) {
            const currentClickedElement = this.$refs[iconElem] && this.$refs[iconElem][0] && this.$refs[iconElem][0].$el ? this.$refs[iconElem][0].$el : null;
            const allsubTasksElements = this.currentStageDetails && this.currentStageDetails[indexOfParent]
            && this.currentStageDetails[indexOfParent].timelineDecisionGroupModels
            && this.currentStageDetails[indexOfParent].timelineDecisionGroupModels[indexParent].tasks
                ? this.currentStageDetails[indexOfParent].timelineDecisionGroupModels[indexParent].tasks : [];

            allsubTasksElements.forEach((element, i) => {
                if (i !== index && this.$refs[`toggle-subtask-user-icon-${indexOfGrandfather}-${indexOfParent}-${indexParent}-${i}`]
                && this.$refs[`toggle-subtask-user-icon-${indexOfGrandfather}-${indexOfParent}-${indexParent}-${i}`][0]
                && this.$refs[`toggle-subtask-user-icon-${indexOfGrandfather}-${indexOfParent}-${indexParent}-${i}`][0].$el) {
                    this.$refs[`toggle-subtask-user-icon-${indexOfGrandfather}-${indexOfParent}-${indexParent}-${i}`][0]
                        .$el.classList.remove("toggle-icon-rotate-90");
                    this.currentSubUserTaskDetails = [];
                }
            });
            const apiUrl = this.isFromPI ? `/engine/task/audit/${userSubTask.id}?isProcessInspector=true` : `/engine/task/audit/${userSubTask.id}`;
            this.$store.dispatch("diagrams/getTaskDetailsTimeline", apiUrl).then(
                data => {
                    this.currentSubUserTaskDetails = data;
                    this.$store.commit("diagrams/setTimelineApprovalLevelDetails", { id: userSubTask.id, data });
                    this.taskApprovalMatrixOpened = userSubTask.id;
                    this.reverseSubLevelArrow(currentClickedElement, indexOfGrandfather, indexOfParent, indexParent, index);
                },
                () => {

                }
            );
        },

        /**
     * @description  rotate sublevel arrow and close collapsible
     */
        reverseSubLevelArrow(currentClickedElement, indexOfGrandfather, indexOfParent, indexParent, index) {
            if (this.currentSubUserTaskDetails && this.currentSubUserTaskDetails.length) {
                if (currentClickedElement) {
                    if (currentClickedElement.classList.contains("toggle-icon-rotate-90")) {
                        currentClickedElement.classList.remove("toggle-icon-rotate-90");
                        this.$refs[`collapsible-subtask-user-${indexOfGrandfather}-${indexOfParent}-${indexParent}-${index}`][0].hide();
                        this.taskApprovalMatrixOpened = null;
                    } else {
                        currentClickedElement.classList.add("toggle-icon-rotate-90");
                        this.$refs[`collapsible-subtask-user-${indexOfGrandfather}-${indexOfParent}-${indexParent}-${index}`][0].show();
                    }
                }
            }
        },

        addMsgBgColor(value) {
            return value === "SMS" ? "background-color: #00CC66" : "background-color: #4285F4";
        },

        /**
     * @description  load more tasks
     */
        loadTasksAfterRefresh() {
            if (this.refreshTimeline || this.changeInComments) {
                this.filterStages = this.timeline;
                this.$emit("refreshTimelineDone");
            }
        },

        /**
     * @description  load more tasks
     */
        loadMoreTasks(itemNumber) {
            const partialTasks = [];

            if (typeof itemNumber === "boolean") {
                this.filterStages = [];
            }

            const approxCount = this.filterStages.length;
            const totalCount = approxCount + this.taskNumberToShow < this.timeline.length ? approxCount + this.taskNumberToShow : this.timeline.length;

            for (let i = approxCount; i < totalCount; i++) {
                partialTasks.push(this.timeline[i]);
            }
            if (partialTasks.length) {
                this.filterStages = this.filterStages.concat(partialTasks);
            }
        },

        /**
     * @description  search bar functionality - search in tasks
     */
        searchInTimeline(newValue) {
            const filterNewValue = newValue.toLowerCase();
            this.filterStages = newValue ? (this.timeline.filter(stage => stage.activityName
            && stage.activityName.toLowerCase().indexOf(filterNewValue) !== -1)) : [...this.timeline];
            this.temporaryFilterData = newValue ? this.filterStages : [];
        },
        isNotUserAction(type) {
            return PI_USER_ACTIONS.indexOf(type) === -1;
        },
        downloadDoc(id) {
            window.open(`/data/attachment/download/attachment/${id}`);
        }
    }
};
